import type { FileForProcessing, IOrder } from '../../../../Model/index.js'
import type { CSVMappingResult, SampleOperationResult } from './CSVModalTypes.js'

export const buildSampleNameMap = (samples: FileForProcessing[]) => {
  let hasDuplicate = false
  return {
    sampleNameMap: samples.reduce(
      (acc, x) => {
        if (x.customerSampleName) {
          if (acc[x.customerSampleName]) {
            console.warn("Duplicate customer sample names - cannot match by name")
            hasDuplicate = true
          } else {
            acc[x.customerSampleName] = x;
          }
        }
        return acc;
      },
      {} as Record<string, FileForProcessing>
    ),
    hasDuplicate
  };
}

export const sampleReplicationSuccess: (
  result: SampleOperationResult,
  allowCreate: boolean,
  existingSample: FileForProcessing,
  row: CSVMappingResult,
  order?: IOrder,
) => boolean = (
  result,
  allowCreate,
  existingSample,
  row,
  order,
) => {
  if (!order) {
    result.errors.push({ type: 'ErrMissingOrder'})
    return false
  }
  if (order.sampleConfiguration !== "COMBINED_SAMPLE_PAIRS") {
    result.errors.push({ type: 'ErrMultiSampleNotAllowed'})
    return false
  }
  if (existingSample.sampleMetadata?.customerSampleName != undefined || existingSample.sampleMetadata !== undefined) {
    result.errors.push({ type: 'ErrCannotDuplicatePopulatedSample'})
    return false
  }
  if (!allowCreate) {
    result.errors.push({ type: 'ErrSampleReplicationNotAllowedInState'})
    return false
  }
  if (!existingSample.poolId) {
    result.errors.push({ type: 'ErrSampleWithoutPoolId' })
    return false
  }
  result.result.push({
    op: 'CreateSample',
    sample: {
      itemType: row.itemType ?? existingSample.itemType,
      forwardFileId: existingSample.forwardFileId,
      reverseFileId: existingSample.reverseFileId,
      isTrimmed: false,
      isMerged: false,
      customerSampleName: row.customerSampleName,
      forwardPrimer: row.forwardPrimer,
      reversePrimer: row.reversePrimer,
    },
    metadata: {
      ...row.metadata,
      customerSampleName: row.customerSampleName ?? "",
      sampleId: undefined
    },
    orderId: order.id,
    poolId: existingSample.poolId,
    poolKey: row.pool?.key,
  })
  return true
}